import React from 'react';
import { Box, Typography } from '@mui/material';
import { PageRoot } from './styles';
import Header from './Header';
export default function ErrorStatePage({ title, subtitle, showHeader = true }) {
    return (
        <PageRoot>
            {showHeader && <Header />}
            <Box flex={1} display="flex" alignItems="center" justifyContent="center">
                <Box textAlign="center" maxWidth={460} p={4}>
                    <Typography variant="h5" fontWeight={700} mb={1.5} color="#111827">
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" lineHeight={1.7}>
                        {subtitle}
                    </Typography>
                </Box>
            </Box>
        </PageRoot>
    );
}
